import { getWithAuthServerSide, postWithOutAuth, deleteWithAuth } from './http.service';
import {
  CREATE_PRESENTATION_SLIDE_URL, GET_PRESENTATION_SLIDES, DELETE_UPLOADED_PRESENTATION_DOCUMENT,
  GENERATE_PRE_SIGNED_URLS, CONVERT_PDF_TO_IMAGE_URL, CONVERT_FILE_TO_PDF,
  UPDATE_PRESENTATION_SLIDE,
} from './url.service';

export const createPresentationSlide = (data) => postWithOutAuth(
  CREATE_PRESENTATION_SLIDE_URL(),
  data
);

export const updatePresentationSlide = (data) => postWithOutAuth(
  UPDATE_PRESENTATION_SLIDE(),
  data
);

export const getPresentationSlides = (userId, auth) => getWithAuthServerSide(
  GET_PRESENTATION_SLIDES(userId),
  auth
);

export const deleteUploadedPresentationDocument = (userId, fileName, auth) => {
  deleteWithAuth(DELETE_UPLOADED_PRESENTATION_DOCUMENT(userId, fileName), auth);
};

export const generatePresignedUrls = (data) => postWithOutAuth(GENERATE_PRE_SIGNED_URLS(), data);

export const convertPdfToImage = (data) => postWithOutAuth(
  CONVERT_PDF_TO_IMAGE_URL(), data
);

export const convertFileToPdf = (data) => postWithOutAuth(
  CONVERT_FILE_TO_PDF(), data
);
